// extracted by mini-css-extract-plugin
export default {"label-small":"kgc3p","label-large":"uKywh","progress-bar":"A1Oio","progress-bar-small":"bytt4","progress-bar-large":"Zvp_L"};